import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'

export const stackProgramsReducer = (state, { payload }) => {
  const { programs } = payload

  return { ...state, programs: _.concat(state.programs, programs), loading: false, page: state.page + 1, fetchMore: false }
}

export const loadingProgramsReducer = (state, { payload }) => {
  const { loading } = payload

  return { ...state, loading }
}

export const doneFetchingReducer = (state, { payload }) => {
  const { doneFetching } = payload

  return { ...state, doneFetching }
}

export const fetchMoreReducer = (state, { payload }) => {
  const { fetchMore } = payload

  return { ...state, fetchMore }
}

export const setProgramsReducer = (state, { payload }) => {
  const { programs } = payload

  return { ...state, programs }
}

export const clearProgramsReducer = (state) => {
  return { ...state, programs: [], page: 1, loading: false, doneFetching: false, fetchMore: true }
}

const dashboardSlice = createSlice({
  name: 'programlist',
  initialState: {
    programs: [],
    loading: false,
    page: 1,
    doneFetching: false,
    fetchMore: true
  },
  reducers: {
    STACK_PROGRAMS: stackProgramsReducer,
    LOADING_PROGRAMS: loadingProgramsReducer,
    SET_PROGRAMS: setProgramsReducer,
    FETCH_MORE: fetchMoreReducer,
    DONE_FETCHING: doneFetchingReducer,
    CLEAR_PROGRAMS: clearProgramsReducer
  }
})

const { actions, reducer } = dashboardSlice

export const {
  STACK_PROGRAMS,
  LOADING_PROGRAMS,
  SET_PROGRAMS,
  FETCH_MORE,
  DONE_FETCHING,
  CLEAR_PROGRAMS
} = actions

export default reducer
